function ReflectionTextContent({ reflection, primaryClassName = 'reflection-text-content-primary' }) {
  const followUpQuestion = (reflection?.follow_up_question || '').trim();
  const followUpAnswer = (reflection?.follow_up_answer || '').trim();

  return (
    <div className="reflection-text-content">
      <div className={primaryClassName}>{reflection?.reflection_text || ''}</div>
      {(followUpQuestion || followUpAnswer) && (
        <div className="reflection-text-content-follow-up">
          {followUpQuestion && (
            <div className="reflection-text-content-follow-up-block">
              <div className="reflection-text-content-follow-up-label">Follow-up question</div>
              <div className="reflection-text-content-follow-up-text">{followUpQuestion}</div>
            </div>
          )}
          {followUpAnswer && (
            <div className="reflection-text-content-follow-up-block">
              <div className="reflection-text-content-follow-up-label">Follow-up response</div>
              <div className="reflection-text-content-follow-up-text">{followUpAnswer}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ReflectionTextContent;
